import styles from './trusted-by.module.scss';
import Image from 'next/image';
import trustedByState from '@components/shared/blocks/trusted-by/trusted-by.state';

const TrustedBy = () => {
  const trustedBy = trustedByState;
  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <h3 className={styles.section__title}>{trustedBy.title}</h3>
        <div className={styles.section__wrap}>
          {[trustedBy.icons, trustedBy.icons].map((row, idx) => (
            <div key={idx} className={`${styles.section__wrap__row}`}>
              {row.map((icon) => (
                <div className={styles.section__wrap__row__item} key={icon.alt}>
                  <Image
                    unoptimized
                    priority
                    src={icon.url}
                    alt={icon.alt}
                    height={icon.height}
                    width={icon.width}
                    layout="fixed"
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TrustedBy;
